var api = "https://api.qingcigame.com";
var Media = document.getElementById('media-play');
var Video = document.getElementById('video-play');
var index = '';
var obj = {
    index: function() {
        $('.index').removeClass('loading');
        this.onscrollNav();
        this.indexBind();
        this.share();
    },
    indexBind: function() {

        $('.close-btn').click(function(event) {
            $('.popup').fadeOut();
            Media.pause();
            Video.pause();
        });

        $('.map-s').on('click', function(event) {
            $('.map-wrap').fadeIn();
        });

        $('.close-btn-2').click(function(event) {
            $('.map-wrap').fadeOut();
        });

        $('.play-btn').click(function(event) {
            $('.video-wrap').fadeIn();
            Media.play();
        });

        $('.rule-details').click(function(event) {
            $('.rule-wrap').fadeIn();
            Media.pause();
            Video.pause();
        });

        $('.details-btn').click(function(event) {
            $('.reward-wrap').fadeIn();
        });

        $('.tab-btn-box').on('click', 'a', function(event) {
            var _data = $(this).attr('data');
            $('.tab-btn-box').removeClass('tab-btn-box-1 tab-btn-box-2').addClass('tab-btn-box-'+_data+'');
            
            index = layer.load(2, {shade: [0.1, '#fff']});
            setTimeout(function(){
                channelTabAjax(_data);
            },1000);  

        });

        $('.reward-tab').on('click', 'a', function(event) {
            $(this).addClass('select').siblings().removeClass('select').parent('.reward-tab').siblings('.reward-info').children('.info').eq($(this).index()).addClass('show').siblings().removeClass('show');
        });

        $('.winner-tab').on('click', 'a', function(event) {
            $(this).addClass('select').siblings().removeClass('select').parent('.winner-tab').siblings('.winner-con').children('.con').eq($(this).index()).addClass('show').siblings().removeClass('show');
        });

        $('.video-list').on('click', 'a', function(event) {
            if($(this).attr('data').length !== 0) {
                $(this).addClass('select').siblings().removeClass('select');
                $('#video-play').attr('src', $(this).attr('data'));
                Media.pause();
                Video.pause();
            } else {
                layer.msg("赛事暂未开始，尽情期待！", { time: 2000 });
            }
        });

        var nullTeam = [
            {name: '虚位以待', sign: '盟'},
            {name: '虚位以待', sign: '盟'},
            {name: '虚位以待', sign: '盟'},
            {name: '虚位以待', sign: '盟'}
        ];

        var liveBroadcastTime = [
            {times: '08/18 20:00', name: '甲组半决赛'},
            {times: '08/18 20:00', name: '甲组半决赛'},
            {times: '08/19 20:00', name: '乙组半决赛'},
            {times: '08/20 20:00', name: '巅峰决赛'},
            {times: '08/20 20:00', name: '巅峰决赛'}
        ];

        var team_config_demo = [
            ['虚位以待','虚位以待','虚位以待','虚位以待','虚位以待','虚位以待','虚位以待','虚位以待'],
            ['虚位以待','虚位以待','虚位以待','虚位以待','虚位以待','虚位以待','虚位以待','虚位以待'],
            ['虚位以待','虚位以待','虚位以待','虚位以待','虚位以待','虚位以待','虚位以待','虚位以待'],
            ['虚位以待','虚位以待','虚位以待','虚位以待']
        ]

        var testData = {
            "code":200,
            "message":"ok",
            "data":{
                "team_list":{"qc":[{"id":1,"team_name":"\u961f\u4f0d1","belong_to":1,"channel":1,"rank":1,"created_at":"2023-08-04 17:01:57","updated_at":"2023-08-11 17:36:35"},{"id":2,"team_name":"\u961f\u4f0d2","belong_to":1,"channel":1,"rank":0,"created_at":"2023-08-04 17:02:40","updated_at":"2023-08-10 09:45:57"},{"id":3,"team_name":"\u961f\u4f0d3","belong_to":1,"channel":1,"rank":0,"created_at":"2023-08-04 17:02:44","updated_at":"2023-08-10 09:45:49"},{"id":4,"team_name":"\u961f\u4f0d4","belong_to":1,"channel":1,"rank":0,"created_at":"2023-08-04 17:02:49","updated_at":"2023-08-04 17:02:49"},{"id":5,"team_name":"\u961f\u4f0d5","belong_to":1,"channel":1,"rank":0,"created_at":"2023-08-04 17:02:55","updated_at":"2023-08-04 17:02:55"},{"id":6,"team_name":"\u961f\u4f0d6","belong_to":1,"channel":1,"rank":0,"created_at":"2023-08-04 17:03:01","updated_at":"2023-08-04 17:03:01"},{"id":7,"team_name":"\u961f\u4f0d7","belong_to":1,"channel":1,"rank":0,"created_at":"2023-08-04 17:03:05","updated_at":"2023-08-04 17:03:05"},{"id":8,"team_name":"\u961f\u4f0d8","belong_to":1,"channel":1,"rank":0,"created_at":"2023-08-04 17:03:10","updated_at":"2023-08-04 17:03:10"},{"id":9,"team_name":"\u961f\u4f0d9","belong_to":2,"channel":1,"rank":0,"created_at":"2023-08-04 17:03:17","updated_at":"2023-08-04 17:03:17"},{"id":10,"team_name":"\u961f\u4f0d10","belong_to":2,"channel":1,"rank":2,"created_at":"2023-08-04 17:03:22","updated_at":"2023-08-11 17:36:53"},{"id":11,"team_name":"\u961f\u4f0d11","belong_to":2,"channel":1,"rank":0,"created_at":"2023-08-04 17:03:26","updated_at":"2023-08-04 17:03:26"},{"id":12,"team_name":"\u961f\u4f0d12","belong_to":2,"channel":1,"rank":3,"created_at":"2023-08-04 17:03:31","updated_at":"2023-08-11 17:37:01"},{"id":13,"team_name":"\u961f\u4f0d13","belong_to":2,"channel":1,"rank":0,"created_at":"2023-08-04 17:03:35","updated_at":"2023-08-04 17:03:35"},{"id":14,"team_name":"\u961f\u4f0d14","belong_to":2,"channel":1,"rank":0,"created_at":"2023-08-04 17:03:40","updated_at":"2023-08-04 17:03:40"},{"id":15,"team_name":"\u961f\u4f0d15","belong_to":2,"channel":1,"rank":0,"created_at":"2023-08-04 17:03:44","updated_at":"2023-08-04 17:03:44"},{"id":16,"team_name":"\u961f\u4f0d16","belong_to":2,"channel":1,"rank":0,"created_at":"2023-08-04 17:03:49","updated_at":"2023-08-04 17:03:49"}],"channel":[{"id":19,"team_name":"\u6e20\u9053_\u961f\u4f0d1","belong_to":1,"channel":2,"rank":2,"created_at":"2023-08-04 17:01:57","updated_at":"2023-08-09 11:02:14"},{"id":20,"team_name":"\u6e20\u9053_\u961f\u4f0d2","belong_to":1,"channel":2,"rank":3,"created_at":"2023-08-04 17:02:40","updated_at":"2023-08-09 10:57:29"},{"id":21,"team_name":"\u6e20\u9053_\u961f\u4f0d3","belong_to":1,"channel":2,"rank":1,"created_at":"2023-08-04 17:02:44","updated_at":"2023-08-09 10:57:12"},{"id":22,"team_name":"\u6e20\u9053_\u961f\u4f0d4","belong_to":1,"channel":2,"rank":0,"created_at":"2023-08-04 17:02:49","updated_at":"2023-08-04 17:02:49"},{"id":23,"team_name":"\u6e20\u9053_\u961f\u4f0d5","belong_to":1,"channel":2,"rank":0,"created_at":"2023-08-04 17:02:55","updated_at":"2023-08-04 17:02:55"},{"id":24,"team_name":"\u6e20\u9053_\u961f\u4f0d6","belong_to":1,"channel":2,"rank":0,"created_at":"2023-08-04 17:03:01","updated_at":"2023-08-04 17:03:01"},{"id":25,"team_name":"\u6e20\u9053_\u961f\u4f0d7","belong_to":1,"channel":2,"rank":0,"created_at":"2023-08-04 17:03:05","updated_at":"2023-08-04 17:03:05"},{"id":26,"team_name":"\u6e20\u9053_\u961f\u4f0d8","belong_to":1,"channel":2,"rank":0,"created_at":"2023-08-04 17:03:10","updated_at":"2023-08-04 17:03:10"},{"id":27,"team_name":"\u6e20\u9053_\u961f\u4f0d9","belong_to":2,"channel":2,"rank":0,"created_at":"2023-08-04 17:03:17","updated_at":"2023-08-04 17:03:17"},{"id":28,"team_name":"\u6e20\u9053_\u961f\u4f0d10","belong_to":2,"channel":2,"rank":0,"created_at":"2023-08-04 17:03:22","updated_at":"2023-08-04 17:03:22"},{"id":29,"team_name":"\u6e20\u9053_\u961f\u4f0d11","belong_to":2,"channel":2,"rank":0,"created_at":"2023-08-04 17:03:26","updated_at":"2023-08-04 17:03:26"},{"id":30,"team_name":"\u6e20\u9053_\u961f\u4f0d12","belong_to":2,"channel":2,"rank":0,"created_at":"2023-08-04 17:03:31","updated_at":"2023-08-04 17:03:31"},{"id":31,"team_name":"\u6e20\u9053_\u961f\u4f0d13","belong_to":2,"channel":2,"rank":0,"created_at":"2023-08-04 17:03:35","updated_at":"2023-08-04 17:03:35"},{"id":32,"team_name":"\u6e20\u9053_\u961f\u4f0d14","belong_to":2,"channel":2,"rank":0,"created_at":"2023-08-04 17:03:40","updated_at":"2023-08-04 17:03:40"},{"id":33,"team_name":"\u6e20\u9053_\u961f\u4f0d15","belong_to":2,"channel":2,"rank":0,"created_at":"2023-08-04 17:03:44","updated_at":"2023-08-04 17:03:44"},{"id":34,"team_name":"\u6e20\u9053_\u961f\u4f0d16","belong_to":2,"channel":2,"rank":0,"created_at":"2023-08-04 17:03:49","updated_at":"2023-08-04 17:03:49"}]},"team_config":[["\u961f\u4f0d1","\u961f\u4f0d2","\u961f\u4f0d3","\u961f\u4f0d4","\u961f\u4f0d5","\u961f\u4f0d6","\u961f\u4f0d7","\u961f\u4f0d8"],["\u961f\u4f0d9","\u961f\u4f0d10","\u961f\u4f0d11","\u961f\u4f0d12","\u961f\u4f0d13","\u961f\u4f0d14","\u961f\u4f0d15","\u961f\u4f0d16"],[],[]],
                "number":1,
                "is_start":false,
                "url":["","",""],
                "rank_list":["","",""]}
        }


        // 联赛数据
        function channelTabAjax(data) {
            $.ajax({
                url: api+"/sword/live/config",
                type: "GET",
                xhrFields: { withCredentials: true },
                async: false,
                data: {
                    channel: data
                },
                success: function(json) {
                    if (json.code === 200) {
                        var team_config = json.data.team_config;
                        var rank_list   = json.data.rank_list;

                        // 显示当前赛事进度
                        $('.live-broadcast-text span').html(liveBroadcastTime[json.data.number].times);
                        $('.live-broadcast-text strong').html(liveBroadcastTime[json.data.number].name);

                        // 甲组数据
                        $('.group-A li, .group-B li').remove();
                        if(team_config[0].length !== 0) {
                            $.each(team_config[0], function(index, values) {
                                $('.group-A').append('<li>'+values+'</li>');
                            });
                        } else {
                            $.each(team_config_demo[0], function(index, values) {
                                $('.group-A').append('<li>'+values+'</li>');
                            });
                        }
                        // 乙组数据
                        if(team_config[1].length !== 0) {
                            $.each(team_config[1], function(index, values) {
                                $('.group-B').append('<li>'+values+'</li>');
                            });
                        } else {
                            $.each(team_config_demo[1], function(index, values) {
                                $('.group-B').append('<li>'+values+'</li>');
                            });
                        }

                        $('.group-C li, .group-D li').remove();
                        // 甲组进阶
                        if(team_config[2].length !== 0) {
                            $.each(team_config[2], function(index, values) {
                                $('.group-C').append('<li><i>'+values.slice(0,1)+'</i><span>'+values+'</span></li>');
                            });
                        } else { 
                            $.each(nullTeam, function(index, values) {
                                $('.group-C').append('<li><i>'+values.sign+'</i><span>'+values.name+'</span></li>');
                            });  
                        }
                        // 乙组进阶
                        if(team_config[3].length !== 0) {
                            $.each(team_config[3], function(index, values) {
                                $('.group-D').append('<li><i>'+values.slice(0,1)+'</i><span>'+values+'</span></li>');
                            });
                        } else { 
                            $.each(nullTeam, function(index, values) {
                                $('.group-D').append('<li><i>'+values.sign+'</i><span>'+values.name+'</span></li>');
                            });  
                        }

                        // 冠军
                        if(typeof(rank_list[0]) !== 'undefined') {
                            $('.ranking-1 i').html(rank_list[0].team_name.slice(0,1));
                            $('.ranking-1 span').html(rank_list[0].team_name);
                        } else {
                            $('.ranking-1 i').html('盟');
                            $('.ranking-1 span').html('虚位以待');
                        }
                        // 亚军
                        if(typeof(rank_list[1]) !== 'undefined') {
                            $('.ranking-2 i').html(rank_list[1].team_name.slice(0,1));
                            $('.ranking-2 span').html(rank_list[1].team_name);
                        } else {
                            $('.ranking-2 i').html('盟');
                            $('.ranking-2 span').html('虚位以待');
                        }
                        // 季军
                        if(typeof(rank_list[2]) !== 'undefined') {
                            $('.ranking-3 i').html(rank_list[2].team_name.slice(0,1));
                            $('.ranking-3 span').html(rank_list[2].team_name);
                        } else {
                            $('.ranking-3 i').html('盟');
                            $('.ranking-3 span').html('虚位以待');
                        }

                        // 进度第几天
                        $('.playing-mode-main').addClass('day-'+json.data.number+'');
                        
                        $('.playing-mode-main').removeClass('play-false');
                        $('.playing-mode-main').removeClass('play-true');

                        if(json.data.url[0].length !== 0 && json.data.is_start == false && json.data.number == 1 ||
                            json.data.url[0].length !== 0 && json.data.url[1].length !== 0 && json.data.url[2].length !== 0 && json.data.is_start == false && json.data.number == 3 || 
                            json.data.url[0].length !== 0 && json.data.url[1].length !== 0 && json.data.url[2].length !== 0 && json.data.is_start == false && json.data.number == 4 || 
                            json.data.url[0].length !== 0 && json.data.url[1].length !== 0 && json.data.is_start == false && json.data.number == 2
                            ) {
                            $('.playing-mode-main').addClass('play-false');
                        } else {
                            $('.playing-mode-main').addClass('play-true');
                        }

                        // 视频添加
                        if(json.data.url[0].length !== 0) {
                            $('.video-1').attr('data', json.data.url[0]).addClass('select').siblings().removeClass('select');
                            $('#video-play').attr('src', $('.video-1').attr('data'));
                        } 
                        if(json.data.url[1].length !== 0) $('.video-2').attr('data', json.data.url[1]);
                        if(json.data.url[2].length !== 0) $('.video-3').attr('data', json.data.url[2]);  
                    }
                },
                complete: function() {
                    layer.close(index);
                }                
            })
        }
        // 默认加载官服数据
        channelTabAjax(1);

        // 点击分享按钮-开启分享弹窗
        $('.share-btn').click(function() {
            $('.share-wrap').fadeIn();
            __bl.sum('巅峰联赛_分享弹窗');
        })

        // 复制功能
        var clipboard = new Clipboard('.copy-btn');
            clipboard.on('success', function(e) {
            console.info('Action:', e.action);
            console.info('Text:', e.text);
            console.info('Trigger:', e.trigger);
            layer.msg("复制链接,快去分享给好友吧~", { time: 2000 });
            e.clearSelection();
            __bl.sum('巅峰联赛_复制链接');
        });

    },
    onscrollNav: function() {
        //滚动事件
        document.onscroll = function(){
            //获取当前滚动的距离
            var btop = document.body.scrollTop||document.documentElement.scrollTop;
            btop > 400 ? $('.nav').addClass('nav-show') : $('.nav').removeClass('nav-show')
        }
    },
    share: function() {
        var share_icon = 'https://download4.qcplay.com/qcgame-admin/paQ7eCrJtaGmBNQE6s8o5FLVmFnwXpCJLx39AUmi.png';
        var share_title = '巅峰联赛';
        var share_min_title = '百万奖金待谁取·神墟群雄战巅峰';
        
        outside.share(share_icon, share_title, share_min_title);
    }
}